export default "__VITE_ASSET__C25GnBRN__"